/**
 * @file Comportement d'arme 'blastSniper' : Laser explosif : faisceau instantane qui s'arrete sur la PREMIERE cible et explose a l'impact.
 */
import type { SimContext } from '../../Context';
import { explode, rollCrit } from '../../combat/damage';
import type { HitOutcome, ShotContext, WeaponBehaviorModule } from '../WeaponBehavior';
import { spawnBeam, targetsOnSegment } from './common';

/** fire : faisceau jusqu'a la premiere cible (ou a la portee max), explosion de zone a l'impact. */
export const blastSniperBehavior: WeaponBehaviorModule = {
  id: 'blastSniper',
  fire(ctx: SimContext, shot: ShotContext): void {
    const w = shot.weapon;
    const p = w.params;
    let x1 = shot.originX + Math.cos(shot.aimAngle) * w.range;
    let y1 = shot.originY + Math.sin(shot.aimAngle) * w.range;
    const first = targetsOnSegment(ctx, shot.originX, shot.originY, x1, y1, p.beamWidth / 2)[0];
    if (first) {
      x1 = first.transform.x;
      y1 = first.transform.y;
    }
    const roll = rollCrit(ctx, w, w.damage);
    spawnBeam(ctx, shot, 'blastSniper', x1, y1, p.beamWidth, p.beamVisibleSeconds);
    explode(ctx, x1, y1, w.explosionRadius, roll.damage, roll.crit, 'blastSniper', p.explosionFalloffAtEdge);
  },
  onHit(): HitOutcome {
    return { consumed: true };
  },
};
